import { IRouteType } from '../../types'
import drgSandbox from './drgSandbox'
import drgSystemwideOverview from './drgSystemwideOverview'

export const routes: IRouteType[] = [
  {
    title: 'Corporate',
    children: [
      {
        title: 'Systemwide Overview',
        link: '/:brand/systemwide_overview',
        default: true,
      },
      {
        title: 'SC Sandbox',
        link: '/:brand/sc_sandbox',
        hideFromNavMenu: true,
      },
    ],
  },
]

export default [drgSystemwideOverview, drgSandbox]
